import { useEffect, useRef, useState } from "react";

interface Options {
  threshold?: number;
  resetOnExit?: boolean; // Si es true, se oculta al salir del viewport
}

export const useInView = ({
  threshold = 0.1,
  resetOnExit = false,
}: Options = {}) => {
  const ref = useRef<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else if (resetOnExit) {
          setIsVisible(false);
        }
      },
      { threshold }
    );

    observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [threshold, resetOnExit]);

  return { ref, isVisible };
};
